import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import clone from 'lodash/clone';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import ApiService from '@/services/apiService';
import WGS84Service from '@/services/wgs84ProjectionService';
import AddressLatLongMixin from '@/components/core/addressLatLongMixin';
export default {
  name: 'CoreAddressPicker',
  mixins: [AddressLatLongMixin],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    addressObject: {
      type: Object,
      required: true
    },
    coordinateLookup: {
      type: Boolean,
      required: false,
      default: true
    },
    mapView: {
      type: Boolean,
      required: false,
      default: true
    },
    markerDraggable: {
      type: Boolean,
      required: false,
      default: true
    },
    floatRule: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      entries: [],
      isLoading: false,
      search: null,
      address: {},
      coordinates: [null, null],
      // if a manual lat/lng is entered via text-field, do not lookup address any more
      pickedManualCoordinates: false,
      fullScreenMap: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    hasValidCoordinate: function hasValidCoordinate() {
      return this.areCoordinatesValid(this.coordinates);
    }
  }),
  watch: {
    addressObject: {
      handler: function handler() {
        this.address = get(this.addressObject, 'address');
        this.coordinates = clone(get(this.addressObject, 'coordinates', this.coordinates));
      },
      deep: true
    },
    coordinates: {
      handler: debounce(function (newCoordinates, oldCoordinates) {
        var _this = this;

        var isFirstChange = oldCoordinates[0] === null && oldCoordinates[1] === null;

        if (isFirstChange || isEqual(newCoordinates, oldCoordinates)) {
          return;
        }

        if (!this.coordinateLookup || this.pickedManualCoordinates) {
          this.addressSelected();
          return;
        }

        var coordinates = this.coordinates.filter(function (c) {
          return !isNaN(parseFloat(c));
        });

        if (coordinates.length >= 2) {
          return ApiService.geoCodeCoordinates(coordinates[1], coordinates[0]).then(function (data) {
            // look up if one of the results matches the given formatted address.
            var matchResult = data.results.find(function (item) {
              return item.formatted_address === _this.address.formatted_address;
            });

            if (matchResult) {
              _this.entries = [matchResult];
            } else {
              _this.entries = [get(data, 'results[0]')];
            } // do not (re)publish, if the address has not changed
            // would lead to an endless loop of coordinate-updates and address-lookups


            if (get(_this.entries, '[0].formatted_address') !== get(_this.address, 'address.formatted_address')) {
              _this.address = _this.entries[0];

              _this.addressSelected();
            }

            return data;
          });
        }
      }, 1000)
    },
    search: debounce(function () {
      // Items have already been loaded
      // if (this.addressSearchResult.length > 0) return
      // Items have already been requested
      if (this.isLoading || this.search === get(this.address, 'formatted_address')) {
        return;
      }

      this.isLoading = true;
      this.remoteLookupAddressCoordinates(this.search);
    }, 500)
  },
  mounted: function mounted() {
    this.initValuesFromProps();
  },
  methods: {
    resetAddress: function resetAddress() {
      this.initValuesFromProps();
      this.entries = [this.address];
      this.search = '';
    },
    initValuesFromProps: function initValuesFromProps() {
      this.address = get(this.addressObject, 'address', {});
      this.coordinates = get(this.addressObject, 'coordinates', this.coordinates);
      this.address = _objectSpread(_objectSpread({}, this.address), {}, {
        formatted_address: get(this.address, 'formatted_address', ''),
        geometry: _objectSpread(_objectSpread({}, get(this.address, 'geometry', {})), {}, {
          location: {
            lat: this.coordinates[1],
            lng: this.coordinates[0]
          }
        })
      });
    },
    handleMarkerUpdate: function handleMarkerUpdate(e) {
      this.coordinates = [e.lon, e.lat];
    },
    handleCoordinateChange: function handleCoordinateChange() {
      this.handleParsingCoordinates(this.coordinates);

      if (this.coordinates[0] === null || this.coordinates[1] === null) {
        return false;
      }

      if (WGS84Service.isValidWgs84({
        lat: this.coordinates[0],
        lon: this.coordinates[1]
      })) {
        this.pickedManualCoordinates = true;
        this.addressSelected();
      }
    },
    handleAddressChange: function handleAddressChange() {
      var newCoordinates = [null, null];
      var addressIsEmptyString = typeof (this.address || '') === 'string' && (this.address || '').trim() === '';

      if (addressIsEmptyString) {
        this.address = {
          formatted_address: ''
        };
      } else if (get(this.address, 'geometry.location.lat')) {
        if (this.coordinateLookup && !this.pickedManualCoordinates) {
          newCoordinates = [this.address.geometry.location.lng, this.address.geometry.location.lat];
        }
      }

      if (this.coordinateLookup && !this.pickedManualCoordinates) {
        this.coordinates = newCoordinates;
      }

      this.addressSelected();
    },
    remoteLookupAddressCoordinates: function remoteLookupAddressCoordinates(address) {
      var _this2 = this;

      var addressIsEmptyString = typeof (this.address || '') === 'string' && (this.address || '').trim() === '';

      if (addressIsEmptyString) {
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      ApiService.checkAddress(address).then(function (data) {
        _this2.entries = clone(data.results);
      }).catch(function (error) {
        console.error('Error request address geomapping', error);
      }).finally(function () {
        return _this2.isLoading = false;
      });
    },
    handleReconnectCoordinates: function handleReconnectCoordinates() {
      var _this3 = this;

      if (get(this.address, 'geometry.location.lat')) {
        this.coordinates = [this.address.geometry.location.lng, this.address.geometry.location.lat];
        this.pickedManualCoordinates = false;
        this.addressSelected(true);
      } else if (get(this.address, 'formatted_address')) {
        ApiService.checkAddress(get(this.address, 'formatted_address')).then(function (data) {
          if (get(data, 'results[0].geometry.location.lng')) {
            _this3.coordinates = [get(data, 'results[0].geometry.location.lng'), get(data, 'results[0].geometry.location.lat')];
            _this3.pickedManualCoordinates = false;

            _this3.addressSelected(true);
          }
        }).catch(function (error) {
          console.error('Error request address geomapping', error);
        });
      }
    },
    addressSelected: function addressSelected() {
      var resetManualLookup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var addressData = {
        address: get(this.address, 'formatted_address'),
        coordinates: this.coordinates,
        pickedManualCoordinates: resetManualLookup ? false : !this.coordinateLookup || this.pickedManualCoordinates
      };
      this.$emit('address-selected', addressData);
    },
    clearAddress: function clearAddress() {
      this.address = {};
      this.coordinates = [];
      this.$emit('address-clear');
    }
  }
};